import { Client, createClient } from '@connectrpc/connect'
import { PlansService } from '@dtx-company/connect-codegen/src/gen/plans/v1/plans_pb'
import { createConnectTransport } from '@connectrpc/connect-web'

export const getPlansServiceBaseUrl = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
      if (process.env.APP_NAME === 'internal-admin') {
        return `http://localhost:3003/internal-admin/api/proxy/atlas-dev-only`
      } else {
        return `http://localhost:3000/api/proxy/atlas-dev-only`
      }
    case 'staging':
      return `https://gateway.stg.flowcode.com/atlas`
    case 'preprod':
      return `https://gateway.preprod.flowcode.com/atlas`
    case 'production':
    default:
      return `https://gateway.flowcode.com/atlas`
  }
}

const plansClient: Client<typeof PlansService> = createClient(
  PlansService,
  createConnectTransport({
    baseUrl: getPlansServiceBaseUrl()
  })
)

export default plansClient
